export default __webpack_public_path__ + "static/table-a2fbca0043294dcaf8c88cf39e2574e1.webm";